import { useState } from "react";
import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  ControlButton,
} from "reactflow";
import { XMarkIcon } from "@heroicons/react/16/solid";

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
  selected,
}) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const [hovered, setHovered] = useState(false);
  const [buttonHovered, setButtonHovered] = useState(false);

  const handleDelete = (e) => {
    e.stopPropagation();
    if (data && data.onDelete) data.onDelete(id);
  };

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <path
        d={edgePath}
        fill="none"
        stroke="transparent"
        strokeWidth={32}
        style={{ cursor: "pointer" }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      />
      {!data?.locked && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: "absolute",
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              fontSize: 12,
              // everything inside EdgeLabelRenderer has no pointer events by default
              // if you have an interactive element, set pointer-events: all
              pointerEvents: "all",
            }}
            className="nodrag nopan"
          >
            <div
              className=" hover:bg-gray-200 rounded-full overflow-hidden border border-gray-400"
              onMouseEnter={() => setButtonHovered(true)}
              onMouseLeave={() => setButtonHovered(false)}
            >
              {(hovered || buttonHovered || selected) && (
                <ControlButton onClick={handleDelete}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      maxWidth: "none",
                      maxHeight: "none",
                    }}
                  >
                    <XMarkIcon
                      className="text-gray-400"
                      style={{
                        width: 22,
                        height: 22,
                        maxWidth: "none",
                        maxHeight: "none",
                      }}
                    />
                  </div>
                </ControlButton>
              )}
            </div>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
}
